import * as React from 'react';

import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';

import { formatPartialDate } from 'Utility/date';
import { newButton } from '../../../../utils/functions';
import { isNil } from 'Utility/ramdaReplacement';
import { IHistoryContext } from 'Containers/FormContextHandler';
import HistoryRow from 'Components/HistoryRow';
import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';

const HuntingtonSymptoms = ({
  documents = [],
  startEdit,
  fm = (): string => '',
}: IHistoryContext<IHuntingtonSymptoms>): React.JSX.Element => {
  const huntingtonSymptoms = documents[0];

  return (
    <HistoryRow
      headerText={fm('diagnosis.huntingtonSymptoms')}
      rowButton={
        startEdit
          ? newButton(
              'huntingtonSymptoms',
              startEdit(huntingtonSymptoms ?? {}, 'huntingtonSymptoms'),
              'general.edit',
              undefined,
              undefined,
              !isNil(((huntingtonSymptoms ?? {}) as IControlProps)._lockedFor),
              undefined,
              undefined,
              huntingtonSymptoms,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(huntingtonSymptoms)}
    >
      <React.Fragment>
        <HistoryRowVerticalItem
          header={fm('diagnosis.symptomOnsetDate')}
          value={
            huntingtonSymptoms?.symptomOnsetDate ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {formatPartialDate(huntingtonSymptoms?.symptomOnsetDate)}
              </div>
            ) : (
              ' - '
            )
          }
        />
        <HistoryRowVerticalItem
          header={fm('diagnosis.huntingtonSymptom.title')}
          value={
            huntingtonSymptoms?.symptoms ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {fm(`diagnosis.huntingtonSymptom.opts.${huntingtonSymptoms?.symptoms}`)}
              </div>
            ) : (
              ' - '
            )
          }
        />
        <HistoryRowVerticalItem
          header={fm('diagnosis.huntingtonSymptom.additionalInformation')}
          value={
            huntingtonSymptoms?.additionalInformation ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {huntingtonSymptoms?.additionalInformation}
              </div>
            ) : (
              ' - '
            )
          }
        />
      </React.Fragment>
    </HistoryRow>
  );
};

export default HuntingtonSymptoms;
